import React from 'react';

import { Modal as BootstrapModal } from 'react-bootstrap';

import { ModalCancelButton, ModalContext } from './index';

interface IModalFooterProps {
    cancelButton?: string;
}

export const ModalFooter = ({cancelButton, children}: React.PropsWithChildren<IModalFooterProps>) => {
    const {variant} = React.useContext(ModalContext);

    return (
        <BootstrapModal.Footer className={`Modal__footer ${variant ? `Modal__footer--${variant}` : ''}`}>
            {children}
            {cancelButton && (
                <ModalCancelButton>{cancelButton}</ModalCancelButton>
            )}
        </BootstrapModal.Footer>
    );
};